declare global {
  interface Window {
    nonce?: string;
    /** Webpack reads this when injecting Module Federation remote scripts (see VM-247). */
    __webpack_nonce__?: string;
  }
}

/**
 * Single adapter for direct browser global access in the shell app.
 * Keeps window usage typed, mockable, and isolated from application entrypoints.
 */
export class BrowserWindowAdapter {
  static isAvailable(): boolean {
    return typeof window !== 'undefined';
  }

  static getCspNonce(): string | undefined {
    if (!this.isAvailable()) {
      return undefined;
    }

    return window.nonce;
  }

  /** Applies the page CSP nonce to webpack for dynamically injected remote scripts. */
  static propagateCspNonceToWebpack(): void {
    if (!this.isAvailable()) {
      return;
    }

    const nonce = this.getCspNonce();
    if (typeof nonce === 'string' && nonce.length > 0) {
      window.__webpack_nonce__ = nonce;
    }
  }
}
